// extracted by mini-css-extract-plugin
module.exports = {"r-mobile":"MarkupBlocksSection_r-mobile__ANchD","r-not-mobile":"MarkupBlocksSection_r-not-mobile__Em_pQ","container":"MarkupBlocksSection_container__0luZ8"};